import React from "react"

import PropTypes from "prop-types"
import Fade from "react-reveal/Fade"

import "./ImageRight.scss"

const ImageRight = ({ section }) => {
  const url = section.image?.url
  const altText = section.image?.alt

  return (
    <section>
      <section className="image-right">
        <figure className="image-right__content">
          <Fade>
            <h2 className="image-left__content__title">
              {section.title || "Lorem Ipsum"}
            </h2>
            <p className="image-left__content__body">
              {section.body ||
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore"}
            </p>
          </Fade>
        </figure>
        <div className="image-right__image">
          <Fade>
            <figure>
              <img
                src={
                  url ||
                  "https://images.unsplash.com/photo-1640622659144-18a1fd885123?ixlib=rb-1.2.1&ixid=MnwxMjA3fDF8MHxlZGl0b3JpYWwtZmVlZHwxfHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60"
                }
                alt={altText}
                loading="lazy"
              />
              {section.image?.caption && (
                <figcaption>{section.image?.caption}</figcaption>
              )}
            </figure>
          </Fade>
        </div>
      </section>
    </section>
  )
}

ImageRight.propTypes = {
  section: PropTypes.object.isRequired,
}

export default ImageRight
